exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-enter {\n    opacity: 0.01;\n}\n\n.example-enter.example-enter-active {\n    opacity: 1;\n    transition: opacity 500ms ease-in;\n}\n\n.example-leave {\n    opacity: 1;\n}\n\n.example-leave.example-leave-active {\n    opacity: 0.01;\n    transition: opacity 300ms ease-in;\n}", ""]);

// exports
